module.exports = __webpack_public_path__ + "img/icon-heart.3cb6a0a7.svg";